export { default } from './part-results';
